
export default {
  name: "H2Block",
  props: {
    // block.num is the auto-incremented "01" / "02" … assigned by the page.
    block: { type: Object, required: true },
  },
};
